// extracted by mini-css-extract-plugin
export default {"placementAdTypeChart":"zlWjI8wz400iR5vN3CVV"};